<div
  class="include-container itinerary jobsv2-{{ colorScheme.colorScheme.value }}"
  *ngIf="viewModel$ | async as viewModel"
>
  <div class="itinerary-header">
    <label class="section-label">Itinerary</label>
    <span
      *ngIf="viewModel.showDockTravelTimeCheckbox"
      class="dock-toggle"
      [class.disabled]="viewModel.dockTravelTimeDisabled"
      [pTooltip]="
        'Include travel time for dock to start and end to dock in the duration of the event'
      "
      (click)="
        !viewModel.dockTravelTimeDisabled &&
          store.dispatch(
            actions.includeDockTravelTimeCheckboxToggled({
              includeDockTravel: !viewModel.includeDockTravel,
            })
          )
      "
    >
      {{ viewModel.includeDockTravel ? '- Remove Docks' : '+ Add Docks' }}
    </span>
  </div>

  <div
    class="step"
    cdkDropList
    (cdkDropListDropped)="
      store.dispatch(
        actions.locationDropped({
          previousIndex: $event.previousIndex,
          currentIndex: $event.currentIndex,
        })
      )
    "
  >
    <div
      cdkDrag
      *ngFor="
        let location of viewModel.eventItineraryLocations;
        let last = last;
        trackBy: trackByLocationName
      "
    >
      <ng-template cdkDragPreview>
        {{ location.name }}
      </ng-template>
      <div class="location">
        <span class="dragHandle"><i class="pi pi-bars"></i></span>
        <p-panel
          #locationPanel
          [toggleable]="true"
          toggler="header"
          expandIcon="pi pi-chevron-up"
          collapseIcon="pi pi-chevron-down"
          (collapsedChange)="
            store.dispatch(
              actions.toggleExpandLocationButtonClicked({
                locationId: location.id,
                collapsed: $event,
              })
            )
          "
          [collapsed]="location.collapsed"
        >
          <ng-template pTemplate="header">
            <div class="location-header">
              <div class="location-icon-column">
                <i [class]="location.icon"></i>
              </div>
              <div class="location-info-column">
                <div class="location-time-row">
                  <span class="time-range">
                    {{ location.arrivalTime }}
                    <ng-container
                      *ngIf="
                        location.departureTime && location.duration !== '0 min'
                      "
                    >
                      - {{ location.departureTime }}
                    </ng-container>
                    <ng-container
                      *ngIf="
                        !location.departureTime || location.duration === '0 min'
                      "
                    >
                      End
                    </ng-container>
                  </span>
                  <span
                    class="duration-abbreviated"
                    *ngIf="
                      location.duration !== '0 min' && location.departureTime
                    "
                    >{{ location.duration }}</span
                  >
                </div>
                <div class="location-address-row">
                  <span class="location-type">{{
                    location.type | titlecase
                  }}</span>
                  <span
                    class="location-address freya-link-button"
                    *ngIf="location.location"
                    (click)="
                      store.dispatch(
                        actions.viewLocationOnGoogleMapsButtonClicked({
                          locationType: locationNameMap[location.type],
                        })
                      )
                    "
                    pTooltip="Open new tab to Google Maps"
                    >{{ location.location?.addressLineOne }}</span
                  >
                </div>
              </div>
            </div>
          </ng-template>

          <div class="location-details">
            <ng-container *ngIf="!location.location">
              <div class="p-field">
                <label>Location</label>
                <p-dropdown
                  #addressDropdown
                  [ngModel]="location?.location?.id"
                  [options]="viewModel.potentialEventLocations"
                  optionLabel="addressLabel"
                  placeholder="Select locations"
                  appendTo="body"
                  [filter]="true"
                  (onChange)="
                    store.dispatch(
                      actions.dropdownLocationSelected({
                        location: $event.value,
                        locationId: location.id,
                      })
                    )
                  "
                >
                  <ng-template let-option pTemplate="item">
                    <div class="location-dropdown-item">
                      <ng-container *ngIf="option.address; else noAddress">
                        <div class="location-type-label">
                          {{ option.type | titlecase }}
                        </div>
                        <div class="location-address-label">
                          {{ option.address }}
                        </div>
                      </ng-container>
                      <ng-template #noAddress>
                        <div class="location-add-label">
                          Add {{ option.type | titlecase }}
                        </div>
                      </ng-template>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>

              <div class="p-field" *ngIf="location.type">
                <label>Address</label>
                <app-address-autocomplete
                  placeholder="Search address"
                  (addressSelected)="
                    store.dispatch(
                      actions.autocompleteLocationSelected({
                        location: $event.value,
                        locationId: location.id,
                        locationType: location.type,
                      })
                    )
                  "
                ></app-address-autocomplete>
              </div>
            </ng-container>

            <div class="p-field">
              <label>Labor Duration</label>
              <app-duration-input
                [showButtons]="false"
                [duration]="location?.estimatedTimeAtLocation || 0"
                (durationChange)="
                  store.dispatch(
                    actions.estimatedTimeAtLocationInputChanged({
                      locationId: location.id,
                      duration: $event,
                    })
                  )
                "
              ></app-duration-input>
            </div>

            <div class="p-field" *ngIf="!last">
              <label>Travel time to next stop</label>
              <app-duration-input
                [showButtons]="false"
                [duration]="location?.totalTravelTimeToNextLocation || 0"
                (durationChange)="
                  store.dispatch(
                    actions.travelTimeToNextLocationInputChanged({
                      locationId: location.id,
                      duration: $event,
                    })
                  )
                "
              ></app-duration-input>
            </div>

            <div class="delete-stop-container">
              <span
                class="remove-stop-btn"
                (click)="
                  store.dispatch(
                    actions.deleteLocationButtonClicked({
                      locationId: location.id,
                    })
                  )
                "
              >
                Remove stop
              </span>
            </div>
          </div>
        </p-panel>
      </div>

      <div *ngIf="!last" class="line">
        <ng-container
          *ngIf="
            viewModel.hasLocationsOrderChanged?.hasChanges &&
              viewModel.hasLocationsOrderChanged.canSaveEvent;
            else showTravelTime
          "
        >
          <i>{{ viewModel.timerMessage }}</i>
          <button
            pButton
            [pTooltip]="
              !viewModel.hasLocationsOrderChanged.canSaveEvent
                ? 'You must assign all new locations before saving changes'
                : ''
            "
            class="p-button-link p-m-0 calculate-btn"
            [disabled]="
              viewModel.isEventUpdating ||
              !viewModel.hasLocationsOrderChanged?.canSaveEvent
            "
            [label]="
              viewModel.isEventUpdating ? 'Calculating...' : 'Calculate now?'
            "
            (click)="store.dispatch(actions.calculateNowButtonClicked())"
          ></button>
        </ng-container>
        <ng-template #showTravelTime>
          <i
            >{{
              location.totalTravelTimeToNextLocation
                | secondsToTimeUnit: false : true
            }}
            to next destination</i
          >
        </ng-template>
      </div>
    </div>
  </div>

  <div class="add-stop-btn-container">
    <span class="dragHandle"><i class="pi pi-bars"></i></span>
    <button
      pButton
      class="add-stop-btn"
      [disabled]="viewModel.isAddStopButtonDisabled?.isDisabled"
      [pTooltip]="viewModel.isAddStopButtonDisabled?.reason || ''"
      tooltipPosition="top"
      icon="pi pi-plus"
      iconPos="left"
      label="Add Stop"
      [outlined]="true"
      (click)="store.dispatch(actions.addStopButtonClicked())"
    ></button>
  </div>

  <p-message
    *ngIf="viewModel.eventHasNoLocations.noLocations"
    severity="error"
    [text]="viewModel.eventHasNoLocations.noLocationsWarning"
    class="no-locations-warning"
  ></p-message>
</div>
